import React from 'react';
import Card from 'components/card/Card';
import {
  CardHeader,
  CardHeaderText,
  CardHeaderTitle
} from 'components/card/card-header';
import { FormattedMessage, useIntl } from 'react-intl';
import messages from 'messages';
import CardBody from 'components/card/CardBody';
import CardFooter from 'components/card/CardFooter';
import SportsList from 'components/list/SportsList';

const SportsReportCard = ({ sports }) => {
  const intl = useIntl();

  return (
    <Card secondary>
      <CardHeader secondary>
        <CardHeaderText
          extraClassNames="u-margin-right-none u-margin-bottom-none"
          style={{ width: '100%' }}
        >
          <CardHeaderTitle>
            <FormattedMessage {...messages.cardLabelTitleSports} />
          </CardHeaderTitle>
        </CardHeaderText>
      </CardHeader>

      <CardBody secondary>
        {sports.length > 0 ? (
          <SportsList
            items={sports}
            defaultVisibleItems={10}
            labelShowLess={intl.formatMessage(messages.cardButtonShowLess)}
            labelShowMore={intl.formatMessage(messages.cardButtonShowAll, {
              count: sports.length
            })}
          />
        ) : (
          <FormattedMessage {...messages.cardLabelNotAllTestsCompleted} />
        )}
      </CardBody>
    </Card>
  );
};

export default SportsReportCard;
